<template>
  <div class="mt-1 py-1 px-2" v-if="userSeatEnabled && billingVersion === 'v1'">
    <p class="text-sm font-medium primary_color">User Seats</p>

    <p class="text-sm secondary_color" v-if="freeTrial">
      Unlimited seats in free trial!
    </p>

    <p class="text-sm secondary_color" v-else-if="freePlan">
      Unlimited seats in free plan!
    </p>

    <p class="text-sm secondary_color" v-else>
      <span class="font-bold text_color">{{ props.userCount }}</span>
      of {{ props.humanSeats }} remaining
    </p>

    <div
      class="w-full progress-bar rounded-full h-3 mt-2 relative"
      v-if="paidPlan"
    >
      <div
        class="h-3 rounded-full bg-gradient-to-r from-blue-400 to-purple-500 transition-all"
        :style="{ width: progressWidthUser }"
      ></div>
    </div>
  </div>

  <div class="mt-1 py-1 px-2">
    <p class="text-sm font-medium primary_color">Credits</p>
    <p class="text-sm secondary_color">
      <span class="font-bold text_color">{{ formattedRemaining }}</span>
      of {{ formattedTotal }} remaining
    </p>
    <div class="w-full progress-bar rounded-full h-3 mt-2 relative">
      <div
        class="h-3 rounded-full bg-gradient-to-r from-blue-400 to-purple-500 transition-all"
        :style="{ width: progressWidth }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import {
  isFreeTrial,
  isFreePlan,
  isPaidPlan,
  hasTrialExpired,
  isBillingUnlimited,
} from "@/src/utils/billingUtils.js";
import store from "@/src/store/index.js";

const props = defineProps({
  remaining: Number,
  billingStatus: String,
  userCount: Number,
  humanSeats: Number,
  total: Number,
  billingVersion: String,
});

const userSeatEnabled = computed(
  () => store.getters["billing/userSeatEnabled"],
);

const progressWidth = computed(() => {
  if (props.remaining >= 0)
    return props.total > 0
      ? `${(1 - props.remaining / props.total) * 100}%`
      : "0%";
  else return "100%";
});

const progressWidthUser = computed(() => {
  if (props.userCount >= 0)
    return props.humanSeats > 0
      ? `${(1 - props.userCount / props.humanSeats) * 100}%`
      : "0%";
  else return "100%";
});

const formattedRemaining = computed(() => props.remaining.toLocaleString());
const formattedTotal = computed(() => props.total.toLocaleString());

const trialExpired = ref(false);
const freeTrial = ref(false);
const freePlan = ref(false);
const paidPlan = ref(false);
const billingUnlimited = ref(false);

onMounted(async () => {
  trialExpired.value = hasTrialExpired();
  freeTrial.value = isFreeTrial();
  freePlan.value = isFreePlan();
  paidPlan.value = isPaidPlan();
  billingUnlimited.value = isBillingUnlimited();
});
</script>

<style scoped>
.progress-bar {
  background: var(--white-opacity-6);
}
</style>
